import { useParams } from "react-router-dom";
import useAssessment from "./useAssessment";
import useLang from "../../../hooks/useLang";
import useAssessmentPreview from "./useAssessmentPreview";
import useModifierModal from "../../forms/hooks/useModifierModal";
import useProfileIdBlock from "./useProfileIdBlock";
import { useLocation } from "react-router-dom";

const useAssessmentReview = () => {
  const lang = useLang();
  const location = useLocation();

  const { assessmentId } = useParams();
  const assessment = useAssessment({ id: assessmentId });
  const { title, articles } = useAssessmentPreview({ assessmentId });

  const handleSubmit = () => {
    return [
      (data) => ({
        profile_id: data?.body?.analysis_profile_id,
      }),
      { isLoading: false },
    ];
  };

  const navigateOnSuccess = (data) => {
    return `${location?.pathname}/new/?profile_id=${data?.profile_id}`;
  };

  const { formAttribs, formActions } = useModifierModal({
    mutationHook: handleSubmit,
    formConfigHook: useProfileIdBlock,
    navigateOnSuccess: navigateOnSuccess,
  });

  const page = {
    hasAccess: assessment?.hasAccess,
    header: {
      title,
      carriedOutBy: {
        ...assessment?.data?.user,
        date: assessment?.data?.date_created,
      },
      buttons: [
        {
          caption: lang("reports.create"),
          title: lang("reports.create"),
          type: "modifier-modal",
          formAttribs: formAttribs,
          ...formActions,
        },
      ],
    },
    articles,
  };

  return page;
};

export default useAssessmentReview;
